import { useOfficeTranslation } from "i18n/OfficeTranslation";
import { OfficeTranslationKey } from "i18n/officeTranslations";
import { Call, CallSpamScores } from "models/Call";
import React from "react";

const categoryLabels: Record<keyof CallSpamScores, OfficeTranslationKey> = {
    scammer: "dashboard.recentCallsCard.spamCategories.scammer",
    telemarketing: "dashboard.recentCallsCard.spamCategories.telemarketing",
    market_research: "dashboard.recentCallsCard.spamCategories.marketResearch",
    opinion_poll: "dashboard.recentCallsCard.spamCategories.opinionPoll",
    courier: "dashboard.recentCallsCard.spamCategories.courier",
    safe: "dashboard.recentCallsCard.spamCategories.safe",
    other: "dashboard.recentCallsCard.spamCategories.other",
};

const CallSpamDetails: React.FC<{ call: Call }> = ({ call }) => {
    const { t, intlLocale } = useOfficeTranslation();
    const scores = call.metadata?.spam_scores;
    if (call.status !== "BLOCKED" || !scores) return null;

    const reports = (Object.keys(categoryLabels) as Array<keyof CallSpamScores>)
        .map(category => ({ category, count: scores[category] }))
        .filter(report => report.count > 0)
        .sort((a, b) => b.count - a.count);
    const primaryReport = reports.find(report => report.category !== "safe" && report.category !== "courier");
    if (!primaryReport) return null;

    const numberFormat = new Intl.NumberFormat(intlLocale);

    return <details className="dashboard-call-spam">
        <summary>
            <i className="mdi mdi-shield-alert-outline" aria-hidden="true" />
            <span>
                {t(categoryLabels[primaryReport.category])}
                <span className="text-muted">
                    {" · "}{t(primaryReport.count === 1
                        ? "dashboard.recentCallsCard.reportCountOne"
                        : "dashboard.recentCallsCard.reportCountOther", { count: numberFormat.format(primaryReport.count) })}
                </span>
            </span>
            <i className="mdi mdi-chevron-down dashboard-call-spam-chevron" aria-hidden="true" />
        </summary>
        <div className="dashboard-call-spam-details">
            <h6>{t("dashboard.recentCallsCard.reportsForNumber")}</h6>
            <dl className="dashboard-call-spam-reports">
                {reports.map(report => <div key={report.category}>
                    <dt>{t(categoryLabels[report.category])}</dt>
                    <dd>{numberFormat.format(report.count)}</dd>
                </div>)}
            </dl>
            <div className="text-muted dashboard-call-spam-source">
                <i className="mdi mdi-shield-check-outline" aria-hidden="true" />
                {t("dashboard.recentCallsCard.spamSource")}
            </div>
        </div>
    </details>;
};

export default CallSpamDetails;
